import ValetBookingUI from './components/ValetBookingFrontend.jsx';

function App() {
  return <ValetBookingUI />;
}

export default App;